import { Streams } from "@graylog/server-api";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import PaginationURL from "util/PaginationURL";
import CurrentUser from "logic/users/CurrentUser";
export const fetchStreams = () => fetch("GET", qualifyUrl("/streams")).then((result) => result.streams).catch((errorThrown) => {
  UserNotification.error(
    i18n.t("notifications.load_failed", { ns: "streams", error: errorThrown }),
    i18n.t("notifications.load_failed_title", { ns: "streams" })
  );
  throw errorThrown;
});
export const searchStreamsPaginated = (page, perPage, query, additional) => {
  const url = PaginationURL(ApiRoutes.StreamsApiController.paginated().url, page, perPage, query, additional);
  return fetch("GET", qualifyUrl(url)).then((response) => {
    const {
      elements,
      query: responseQuery,
      attributes,
      pagination: { count, total, page: responsePage, per_page: responsePerPage }
    } = response;
    return {
      list: elements,
      attributes,
      pagination: {
        count,
        total,
        page: responsePage,
        perPage: responsePerPage,
        query: responseQuery
      }
    };
  });
};
export const updateStream = (streamId, data) => fetch("PUT", qualifyUrl(ApiRoutes.StreamsApiController.update(streamId).url), data).catch((errorThrown) => {
  UserNotification.error(
    i18n.t("notifications.update_failed", { ns: "streams", error: errorThrown }),
    i18n.t("notifications.update_failed_title", { ns: "streams" })
  );
  throw errorThrown;
});
export const removeStream = (streamId) => Streams.remove(streamId).then(() => CurrentUser.reload());
export const pauseStream = (streamId) => Streams.pause(streamId).catch((errorThrown) => {
  UserNotification.error(
    i18n.t("notifications.pause_failed", { ns: "streams", error: errorThrown }),
    i18n.t("notifications.pause_failed_title", { ns: "streams" })
  );
  throw errorThrown;
});
export const resumeStream = (streamId) => Streams.resume(streamId).catch((errorThrown) => {
  UserNotification.error(
    i18n.t("notifications.resume_failed", { ns: "streams", error: errorThrown }),
    i18n.t("notifications.resume_failed_title", { ns: "streams" })
  );
  throw errorThrown;
});
export const cloneStream = (streamId, data) => fetch("POST", qualifyUrl(ApiRoutes.StreamsApiController.cloneStream(streamId).url), data).catch((errorThrown) => {
  UserNotification.error(
    i18n.t("notifications.clone_failed", { ns: "streams", error: errorThrown }),
    i18n.t("notifications.clone_failed_title", { ns: "streams" })
  );
  throw errorThrown;
}).then(() => CurrentUser.reload());
export const testMatch = (streamId, message) => fetch("POST", qualifyUrl(ApiRoutes.StreamsApiController.testMatch(streamId).url), message).catch(
  (error) => {
    UserNotification.error(
      i18n.t("notifications.test_match_failed", { ns: "streams", error: error.message }),
      i18n.t("notifications.test_match_failed_title", { ns: "streams" })
    );
    throw error;
  }
);
